import urls from './urls.json';

const partnersUrlFromEnv = window.PARTNER_URL;

export default partnersUrlFromEnv || urls.partnersUrl;
